import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { setCustomUserAgent } from "./common/customUserAgent";
import { companies, getDefaultCompany } from "./common/config/companies";

// Первый сегмент URL = папка компании (asblk, lk, krklk, ...).
// Из него собирается basename роутера, чтобы одна и та же сборка
// работала в любой подпапке компании без пересборки.
const companySegment = window.location.pathname.split("/")[1] || "";
const isKnownCompany = companies.some((c) => c.segments.indexOf(companySegment) !== -1);
const defaultSegment = getDefaultCompany().segments[0];

if (process.env.NODE_ENV === "development" && companySegment === "") {
  // Локально (npm start): компания в URL не указана — подставляем дефолт.
  window.location.replace("/" + defaultSegment + "/");
} else if (companySegment !== "" && !isKnownCompany) {
  // Неизвестный сегмент компании — не показываем белый экран, уводим на дефолтную компанию.
  window.location.replace("/" + defaultSegment + "/");
} else {
  // Определяем компанию и применяем её тему до первого рендера,
  // чтобы на первом кадре не было пустого фона/цветов.
  setCustomUserAgent();
  ReactDOM.render(
    <BrowserRouter basename={"/" + companySegment}>
      <App />
    </BrowserRouter>,
    document.getElementById("rooterast")
  );
}
